import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputMaskModule } from 'primeng/inputmask';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'kon-phone-number-type',
  standalone: true,
  imports: [CommonModule, InputMaskModule, ReactiveFormsModule],
  template: `<p-inputMask
    #phoneNumber
    mask="(+999) 999-999-999"
    [formControl]="$any(formControl)"
    placeholder="(+421) 000-000-000"
  ></p-inputMask>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyPhoneNumberTypeComponent extends FieldType<FormlyFieldConfig> {}
